import { render, staticRenderFns } from "./EditSourceWiseTransacionFeeConfiguration.vue?vue&type=template&id=b388a1d8&"
import script from "./EditSourceWiseTransacionFeeConfiguration.vue?vue&type=script&lang=js&"
export * from "./EditSourceWiseTransacionFeeConfiguration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports